// src/user/pages/profile.js
import React from "react";
import { Redirect, useHistory } from "react-router-dom";
import { useAuth } from "../../context/authContext";
import "./profile.css";
import { deleteUser, solicitarRecuperacionPassword } from "../../services/api";
import toast from "react-hot-toast";

export default function Profile() {

  const { isAuth, user, logout } = useAuth();
  const history = useHistory();

  if (!isAuth) return <Redirect to="/login" />;

  const createdDate = user?.createdAt
    ? new Date(user.createdAt).toLocaleDateString()
    : "—";

  const handleDelete = async () => {

    const confirmDelete = window.confirm(
      "¿Seguro que deseas eliminar tu cuenta? Esta acción no se puede deshacer."
    );

    if (!confirmDelete) return;

    try {

      await deleteUser(user._id);

      logout();

      history.push("/");

    } catch (e) {

      toast.error("No se pudo eliminar la cuenta. Intenta nuevamente.");
      console.error(e);

    }

  };

  const handleEditAccount = async () => {

    try {

      await solicitarRecuperacionPassword({
        correo: user.correo
      });

      toast.success(
        "Se envió un enlace a tu correo para editar tu cuenta."
      );

    } catch (e) {

      toast.error("No se pudo enviar el correo de recuperación.");
      console.error(e);

    }

  };

  return (
    <div className="container profile-page">
      <section className="card profile-card">

        <h2>Mi cuenta</h2>

        <div className="profile-grid">

          <div>
            <div className="profile-label">Usuario</div>
            <div className="profile-value">{user?.nombreUsuario || "—"}</div>
          </div>

          <div>
            <div className="profile-label">Correo</div>
            <div className="profile-value">{user?.correo || "—"}</div>
          </div>

          <div>
            <div className="profile-label">Creado</div>
            <div className="profile-value">{createdDate}</div>
          </div>

        </div>

        <div className="profile-actions">

          <button
            className="btn btn-primary"
            onClick={handleEditAccount}
          >
            Editar cuenta
          </button>

          <button
            className="btn btn-logout"
            onClick={logout}
          >
            Cerrar sesión
          </button>

          <button
            className="btn btn-delete"
            onClick={handleDelete}
          >
            Eliminar cuenta
          </button>

        </div>

      </section>
    </div>
  );
}